// extracted by mini-css-extract-plugin
module.exports = {"home":"UserListPage-styles-module--home--3HSUk","title":"UserListPage-styles-module--title--co8wP","subtitle":"UserListPage-styles-module--subtitle--gSmQD"};